import Vue from 'vue'
import App from './App.vue'
import router from './router'
import utils from './utils/index.js'

Vue.prototype.$utils = utils

// 插件/组件导入（按类别分组，清晰易找）
import Toast from './plugins/toast'
import DisabledPOP from '@/components/DisabledPOP.vue'
import IpPop from '@/components/IpPop.vue'
import GlobalLoading from '@/components/GlobalLoading.vue'

Vue.config.productionTip = false

// ===================== 1. 全局方法封装（Token操作） =====================
/**
 * 全局Token操作方法
 * 用法：this.$token.get() / this.$token.isLogin() / Vue.prototype.$token.isLogin()
 */
Vue.prototype.$token = Object.freeze({ // 冻结对象，防止意外修改
  // 获取token（空值兜底）
  get() {
    return localStorage.getItem('token') || ''
  },
  // 设置token（类型校验）
  set(token) {
    if (typeof token !== 'string') {
      console.error('[Token Error] token必须为字符串类型')
      return
    }
    localStorage.setItem('token', token)
  },
  // 删除token
  remove() {
    localStorage.removeItem('token')
  },
  // 判断是否登录
  isLogin() {
    return !!this.get()
  }
})

// ===================== 2. 全局插件安装（统一管理） =====================
/**
 * 安装全局插件
 */
const installPlugins = () => {
  Vue.use(Toast) // 提示插件
}
installPlugins()

// ===================== 3. 全局弹窗组件封装（抽离为通用方法） =====================
/**
 * 挂载全局弹窗组件
 * @param {VueComponent} Component - 弹窗组件
 * @param {string} prototypeKey - 挂载到Vue原型的key
 * @returns {object} 弹窗实例方法
 */
const mountGlobalPopup = (Component, prototypeKey) => {
  // 创建组件构造器
  const Constructor = Vue.extend(Component)
  const instance = new Constructor()
  // 挂载组件（不指定el，手动插入DOM）
  const vm = instance.$mount()
  // 防止重复插入DOM
  if (!document.body.contains(vm.$el)) {
    document.body.appendChild(vm.$el)
  }
  // 挂载到Vue原型
  Vue.prototype[prototypeKey] = {
    // 透传方法，支持参数
    open: (...args) => instance.open(...args),
    // 可选：添加关闭方法（通用）
    close: () => instance.close?.()
  }
  return instance
}

// 挂载全局弹窗（统一调用，避免重复代码）
mountGlobalPopup(DisabledPOP, '$pop') // 禁用弹窗
mountGlobalPopup(IpPop, '$IpPop')     // IP弹窗
mountGlobalPopup(GlobalLoading, '$loading')     // IP弹窗

// ===================== 4. 实例化Vue（最终入口） =====================
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')